import { useQuery } from '@apollo/client';
import CircularProgress from 'components/CircularProgress';
import React from 'react';
import { GET_SERVICE_TYPES } from 'services/graphql/queries/services.query';
import { OrderEnum } from 'types/common';
import { IService } from 'types/services';

import ServiceList from './components/ServiceList';

const ServiceTypes: React.FC = () => {
  const { data, loading, refetch } = useQuery<{ findServiceTypeEntity: { data: IService[] } }>(GET_SERVICE_TYPES, {
    variables: {
      order: {
        createdAt: OrderEnum.ASC,
      },
      pagination: { take: 50 },
    },
  });
  const services = data?.findServiceTypeEntity?.data;
  return (
    <>
      {!loading && services && <ServiceList services={services} refetch={refetch} />}
      {loading && <CircularProgress />}
    </>
  );
};
export default React.memo(ServiceTypes);
